import { qualifyUrls } from "routing/Routes";
const DataLakeRoutes = {
  ARCHIVE: {
    LIST: "/data-lake/setup",
    show: (archiveId) => `/data-lake/setup/${archiveId}`
  },
  BACKEND: "/data-lake/setup/backend",
  CONFIGURATION: "/data-lake/setup/configuration",
  PREVIEW: "/data-storage/preview",
  RETRIEVALS: "/data-lake/retrievals",
  CONNECTORS: "/data-lake/connectors"
};
const routes = qualifyUrls(DataLakeRoutes);
export default {
  ...routes,
  unqualified: DataLakeRoutes
};
